function extractUrlsFromMarkdown(markdown: string) {
  const combinedRegex =
    /(!?)\[([^\]]*)\]\((https?:\/\/[^\s]+)(?:\s+"([^"]*)")?\)/g

  const results: string[] = []
  let match: RegExpExecArray | null
  while ((match = combinedRegex.exec(markdown)) !== null) {
    results.push(match[3])
  }
  return results
}

// Sanitize the markdown content
export function cleanUpContent(markdown: string) {
  const urls = extractUrlsFromMarkdown(markdown)
  let cleanedContent = markdown
  urls.forEach((url) => {
    const fixedUrl = url.replace('\\&', '&')
    if (fixedUrl !== url) {
      cleanedContent = cleanedContent.replace(url, fixedUrl)
    }
  })

  return cleanedContent
}

/**
 * Unescapes special Markdown characters that were previously escaped with backslashes.
 * For example: \* becomes *, \_ becomes _, etc.
 *
 * @param str - The string containing escaped Markdown characters
 * @returns The unescaped string with special characters restored
 */
export function unescapeMarkdown(str: string) {
  return str.replace(/\\([_\\`*{}\[\]()#+\-.!])/g, '$1')
}

export function getPdfPath(content: string) {
  const trimmed = content.trim()
  if (!trimmed.length) return null
  const path = unescapeMarkdown(trimmed)
  return /^[A-Za-z0-9/_\-]+\.pdf$/i.test(path) ? path : null
}
